import { http } from '../../config/axios'

export default function gerarPdfFatura(id:string) :Promise<Blob>{
    return http.get('/api/fatura/gerarpdf/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao gerarPdfFatura')
        return new Blob()
    })
}
